import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { COLORS } from "../Token";
import { AssignedAsset } from "../Types";

interface AssetConfirmationCardProps {
  asset: AssignedAsset;
}

export function AssetConfirmationCard({ asset }: AssetConfirmationCardProps) {
  if (!asset.hasAsset) return null;

  return (
    <Box p={4} mb={6} borderRadius="16px" bg="#F0F8F3" border="1.5px solid #CFE5D8">
      <Flex align="center" justify="space-between" wrap="wrap" gap={2} mb={2}>
        <Flex align="center" gap={2}>
          <Box w="8px" h="8px" borderRadius="full" bg={COLORS.brand} />
          <Text fontWeight={600} fontSize="sm" color={COLORS.brand}>Hardware & Asset Assignment</Text>
        </Flex>
        <Badge colorScheme="green" borderRadius="full" px={2.5} py={0.5} fontSize="xs">Laptop Assigned</Badge>
      </Flex>

      <Flex wrap="wrap" gap={4} align="center" justify="space-between">
        <Box>
          <Text fontWeight={700} fontSize="16px" color={COLORS.ink}>{asset.assetName || "Company Laptop"}</Text>
          <Text fontSize="xs" color={COLORS.inkSoft} mt={0.5}>Asset Code: <b>{asset.assetCode || "AST-001"}</b>{asset.serialNo && ` · S/N: ${asset.serialNo}`}</Text>
        </Box>

        {asset.issueDate && (
          <Box textAlign={{ base: "left", sm: "right" }}>
            <Text fontSize="11px" color={COLORS.inkSoft}>Issue Date</Text>
            <Text fontSize="xs" fontWeight={600} color={COLORS.ink}>{asset.issueDate}</Text>
          </Box>
        )}
      </Flex>
    </Box>
  );
}
